import { DialogRef } from '@angular/cdk/dialog';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export abstract class DialogBaseComponent {
    readonly destroyRef = inject(DestroyRef);
    readonly dialogRef = inject(DialogRef);

    protected constructor() {
        this.dialogRef.overlayRef
            .outsidePointerEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((event) => {
                if (event?.button === 0 && !this.dialogRef.config.disableClose) {
                    this.close();
                }
            });
    }

    close(success?: boolean): void {
        this.dialogRef.close(success);
    }
}
